import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
var r = {
	12: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 12 12",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.99986 0.712524C8.92001 0.712524 11.2871 3.07974 11.2872 5.99988C11.2872 8.92008 8.92006 11.2872 5.99986 11.2872C3.07972 11.2872 0.712502 8.92003 0.712502 5.99988C0.712581 3.07979 3.07977 0.712604 5.99986 0.712524ZM5.99986 7.68738C5.64791 7.68754 5.36265 7.97333 5.36265 8.32532C5.36281 8.67717 5.64801 8.96237 5.99986 8.96252C6.35177 8.96245 6.63764 8.67722 6.63779 8.32532C6.63779 7.97328 6.35187 7.68746 5.99986 7.68738ZM5.99986 2.96252C5.68933 2.96268 5.43736 3.21446 5.43736 3.52502V6.52502C5.43736 6.83559 5.68933 7.08737 5.99986 7.08752C6.31045 7.08745 6.56236 6.83564 6.56236 6.52502V3.52502C6.56236 3.21441 6.31045 2.9626 5.99986 2.96252Z",
				fill: "#C93829"
			})
		}),
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.99981 0.950012C11.8933 0.950012 15.0495 4.1063 15.0496 7.99982C15.0496 11.8934 11.8934 15.0496 7.99981 15.0496C4.10629 15.0495 0.950001 11.8934 0.950001 7.99982C0.950106 4.10636 4.10635 0.950118 7.99981 0.950012ZM7.99981 10.2498C7.53054 10.25 7.1502 10.6311 7.1502 11.1004C7.15041 11.5695 7.53067 11.9498 7.99981 11.95C8.46903 11.9499 8.85018 11.5696 8.85039 11.1004C8.85039 10.631 8.46916 10.2499 7.99981 10.2498ZM7.99981 3.95001C7.58577 3.95022 7.24981 4.28593 7.24981 4.70001V8.70001C7.24981 9.1141 7.58577 9.4498 7.99981 9.45001C8.41393 9.44991 8.74981 9.11416 8.74981 8.70001V4.70001C8.74981 4.28586 8.41393 3.95012 7.99981 3.95001Z",
				fill: "#C93829"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 20 20",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.99976 1.1875C14.8667 1.1875 18.8119 5.13286 18.812 9.99976C18.812 14.8668 14.8668 18.812 9.99976 18.812C5.13286 18.8119 1.1875 14.8667 1.1875 9.99976C1.18763 5.13294 5.13294 1.18763 9.99976 1.1875ZM9.99976 12.8123C9.41318 12.8125 8.93774 13.2888 8.93774 13.8755C8.93801 14.4619 9.41334 14.9372 9.99976 14.9375C10.5863 14.9374 11.0627 14.462 11.063 13.8755C11.063 13.2888 10.5864 12.8124 9.99976 12.8123ZM9.99976 4.9375C9.48221 4.93776 9.06226 5.3574 9.06226 5.875V10.875C9.06226 11.3926 9.48221 11.8122 9.99976 11.8125C10.5174 11.8124 10.9373 11.3927 10.9373 10.875V5.875C10.9373 5.35731 10.5174 4.93763 9.99976 4.9375Z",
				fill: "#C93829"
			})
		}),
		width: 20,
		height: 20
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.9997 1.42499C17.84 1.42499 22.5743 6.15942 22.5744 11.9997C22.5744 17.8401 17.8401 22.5744 11.9997 22.5744C6.15943 22.5742 1.425 17.84 1.425 11.9997C1.42516 6.15952 6.15953 1.42515 11.9997 1.42499ZM11.9997 15.3747C11.2958 15.375 10.7253 15.9466 10.7253 16.6506C10.7256 17.3543 11.296 17.9247 11.9997 17.925C12.7035 17.9248 13.2753 17.3544 13.2756 16.6506C13.2756 15.9465 12.7037 15.3749 11.9997 15.3747ZM11.9997 5.92499C11.3787 5.9253 10.8747 6.42886 10.8747 7.04999V13.05C10.8747 13.6711 11.3787 14.1747 11.9997 14.175C12.6209 14.1748 13.1247 13.6712 13.1247 13.05V7.04999C13.1247 6.42876 12.6209 5.92515 11.9997 5.92499Z",
				fill: "#C93829"
			})
		}),
		width: 24,
		height: 24
	}
}, i = ({ size: t = 16, ...i }) => /* @__PURE__ */ n(e, {
	source: r[t],
	...i
});
//#endregion
export { i as StatusFailedIcon };
